import Header from '~/components/container/Header'
import { CallProvider } from '~/contexts/CallContext'
import type { LayoutProps } from '~/types/layout'

const DefaultLayout = ({ children }: LayoutProps) => {
  return (
    <CallProvider>
      <Header />
      <main className="flex h-[calc(100vh-6rem)] w-full p-4">{children}</main>
      <footer className="bg-white p-2 text-center text-xs text-gray-500">
        Copyright © {new Date().getFullYear()} JBA Antrean System. All rights reserved.
      </footer>
    </CallProvider>
  )
}

export default DefaultLayout
